import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../../_helpers/Api'
import { useParams, useHistory } from 'react-router-dom'
import * as Constants from '../../../../../_config/app'

//partials
import Table from './Table'
import { fromInfo, trans } from '../../../../../_providers/Translation'

//modals
import Success from '../../../../modals/messages/Success'
import Error from '../../../../modals/messages/Error'
import loader from '../../../../../assets/img/loader.svg'
import AddParts from '../modals/AddParts'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import infoIcon from '../../../../../assets/img/icons/info-black.png'
import ReactTooltip from 'react-tooltip'
import TableStock from './TableStock'
import TableFiles from './TableFiles'
import Help from '../../../../partials/Help'
import { Menu, MenuItem } from '@mui/material'

// images
import clientImage from "@/assets/img/reservations/icons/client.svg"
import deviceImage from "@/assets/img/reservations/icons/device.svg"
import uploadFileImage from "@/assets/img/reservations/icons/upload-file.svg"
import downloadOfferImage from "@/assets/img/reservations/icons/download-offer.svg"
import sendOfferImage from "@/assets/img/reservations/icons/send-offer.svg"

function Index(props) {
    const fileInputRef = useRef()

    const auth = useAuthDataContext()
    const params = useParams().id
    const history = useHistory()
    const [selectedPartsIds, setSelectedPartsIds] = useState([])
    const [selectedFilesIds, setSelectedFilesIds] = useState([])
    const [toIncludeLabourInQuote, setToIncludeLabourInQuote] = useState(false)
    const [sendOfferAnchorEl, setSendOfferAnchorEl] = useState(null)
    const sendOfferButtonRef = useRef(null)
    const [selectedApplianceIdx, setSelectedApplianceIdx] = useState(0)
    const [fileUploadError, setFileUploadError] = useState(null)

    const reservation = props.data

    const [parts, setParts] = useState({
        data: [],
        loading: true,
        refresh: null,
    })

    const [stockParts, setStockParts] = useState({
        data: [],
        loading: true,
        refresh: null,
    })

    const [files, setFiles] = useState({
        data: [],
        loading: true,
        refresh: null,
    })

    //refs
    const partsModalRef = useRef(null)
    const quoteModalRef = useRef(null)
    const quoteErrorModalRef = useRef(null)
    const filesModalRef = useRef(null)

    useEffect(() => {
        loadData()
        loadStockData()
        loadFiles()
    }, [])


    const loadData = () => {

        // setParts(parts => ({
        //     ...parts,
        //     loading: true,
        // }))

        Api.get(`reservations/parts?id=${params}`)
            .then(res => {
                setParts(parts => ({
                    ...parts,
                    data: res.data,
                    loading: false,
                }))
            })
    }

    const loadStockData = () => {

        // setStockParts(parts => ({
        //     ...parts,
        //     loading: true,
        // }))

        Api.get(`reservations/stockparts?id=${params}`)
            .then(res => {
                setStockParts(parts => ({
                    ...parts,
                    data: res.data,
                    loading: false,
                }))
            })
    }

    const loadFiles = () => {
        Api.get(`reservations/uploaded-files?id=${params}`)
            .then(res => {
                setFiles(files => ({
                    ...files,
                    data: res.data.files,
                    loading: false,
                }))
            })
    }


    const handleDeletePart = id => {
        Api.post('ordered-parts/delete', {
            id: id
        }).then(() => {
            loadData()
            // props.calculatePrice();
            props.refreshData()
        })
    }

    const handleDeleteFile = id => {
        Api.post('reservations/uploaded-files/delete', {
            id: id
        }).then(() => {
            loadData()
            props.refreshData()
        })
    }

    const handleRemoveStockPart = id => {
        Api.post('storage/detach-from-reservation', {
            used_id: id
        }).then(() => {
            loadStockData()
            // props.calculatePrice();
            props.refreshData()
        })
    }

    const handleAddPart = () => {
        partsModalRef.current.open()
    }

    const handleUpdatePart = data => {
        // let array = [...parts.data];

        // let index = array.findIndex(p => {
        //     return Number(data.id) === Number(p.id);
        // });

        // if (index !== null) {
        //     array[index] = data;

        //     setParts(prev => ({
        //         ...prev,
        //         data: array
        //     }));
        // }

        loadData()
        // props.calculatePrice();
        props.refreshData()
    }

    const handleUpdateFile = data => {
        loadData()
        props.refreshData()
    }

    const handleSendQuote = (via) => {
        setSendOfferAnchorEl(null)

        Api.post('reservations/parts/quote?parts=' + selectedPartsIds + '&files=' + selectedFilesIds + '&labour=' + toIncludeLabourInQuote + (via ? '&via=' + via : ''), {
            id: params
        }).then(res => {
            if (res.data.success) {
                quoteModalRef.current.open()
            } else {
                quoteErrorModalRef.current.open(res.data.message || trans('headings.error3'))
            }
        }).catch(err => {
            quoteErrorModalRef.current.open(trans('headings.error3'))
        })
    }

    const saveFiles = async (files) => {

        const data = new FormData()

        data.append('id', params)

        files.forEach(file => {
            data.append('files[]', file)
        })

        Api.post('reservations/files', data)
            .then(res => {
                if (res.data.success) {
                    filesModalRef.current.open()
                    props.refreshData()
                } else {
                    const msg = res.data.message || trans('headings.error3')
                    setFileUploadError(msg)
                    quoteErrorModalRef.current.open(msg)
                }
            })
            .catch(err => {
                const msg = err.response?.data?.message || trans('headings.error3')
                setFileUploadError(msg)
                quoteErrorModalRef.current.open(msg)
            })
    }

    const handleAttachFiles = () => {
        fileInputRef.current.click()
    }

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files) // Convert FileList to Array
        if (files.length > 0) {
            saveFiles(files)
        }
    }

    const handleDownloadQuote = () => {
        window.open(Constants.App.api + 'reservations/parts/quote/download?id=' + params + '&token=' + auth.token() + '&parts=' + selectedPartsIds + '&labour=' + toIncludeLabourInQuote)
    }

    const refreshData = () => {
        loadData()
        loadStockData()

        // props.calculatePrice();
        props.refreshData()
    }

    const refreshPartsData = () => {
        loadData()
        // props.calculatePrice();
        props.refreshData()
    }

    return (
        <>
            <Success
                ref={quoteModalRef}
                mainMessage={trans('headings.success9')}
            />

            <Success
                ref={filesModalRef}
                mainMessage={trans('headings.success15')}
            />

            <Error
                ref={quoteErrorModalRef}
                mainMessage={fileUploadError || trans('headings.error3')}
            />

            <AddParts
                ref={partsModalRef}
                reservation={reservation}
                refreshData={refreshPartsData}
            />

            {parts.loading
                ?
                <img src={loader} alt="loading" />
                :
                <>

                    <div id="reservation-parts">
                        <div
                            className="row"
                            style={{
                                marginBottom: "0"
                            }}
                        >
                            <div className="col" style={{ marginRight: '5px' }}>
                                <div className='pannel'>
                                    <div className='head'>
                                        <img src={clientImage} alt="client" />
                                        {trans('tables.clientInfo')}
                                    </div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {trans('tables.name')}

                                                </td>
                                                <td>
                                                    {reservation.customer.name} {reservation.customer.lastname}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {trans('tables.contractorCompany')}
                                                </td>
                                                <td>
                                                    {reservation.contractor
                                                        ?
                                                        reservation.contractor.name
                                                        :
                                                        ''
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {trans('tables.address')}
                                                </td>
                                                <td>
                                                    {reservation.full_address}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {trans('tables.phone')}
                                                </td>
                                                <td>
                                                    {reservation.phone_formatted}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {trans('tables.email')}
                                                </td>
                                                <td>
                                                    {reservation.email}
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col" style={{ marginLeft: '5px' }}>
                                {(() => {
                                    const appliances = reservation.appliances || []
                                    const ap = appliances[selectedApplianceIdx] || {}
                                    const longestLabel = appliances.reduce((max, a) => {
                                        const label = [a.appliancecategory?.name, a.appliancebrand?.name].filter(Boolean).join(' - ')
                                        return label.length > max ? label.length : max
                                    }, 0)
                                    const selectWidth = Math.max(100, longestLabel * 8 + 55)
                                    return (
                                        <div className='pannel'>
                                            <div className='head'>
                                                <img src={deviceImage} alt="device" />
                                                <div className='left' style={{ flexShrink: 0 }}>
                                                    {appliances.length > 1
                                                        ? `${trans('tables.productInfoPlural')} (${appliances.length})`
                                                        : trans('tables.productInfo')
                                                    }
                                                </div>
                                                {appliances.length > 1 && (
                                                    <div className='right'>
                                                        <select
                                                            value={selectedApplianceIdx}
                                                            onChange={e => setSelectedApplianceIdx(Number(e.target.value))}
                                                            style={{ width: selectWidth + 'px' }}
                                                        >
                                                            {appliances.map((ap, i) => (
                                                                <option key={i} value={i}>
                                                                    {[ap.appliancecategory?.name, ap.appliancebrand?.name].filter(Boolean).join(' - ') || i + 1}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}
                                            </div>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>{trans('tables.category')}</td>
                                                        <td>{ap.appliancecategory?.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{trans('tables.make')}</td>
                                                        <td>{ap.appliancebrand?.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{trans('tables.model')}</td>
                                                        <td>{ap.appliancemodel?.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{trans('tables.serialNo')}</td>
                                                        <td>{ap.serial_no}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{trans('tables.productCode')}</td>
                                                        <td>{ap.product_code}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                })()}
                            </div>
                        </div>

                        <div className='pannel'>
                            <div className='head'>
                                <div className='left'>
                                    {trans('headings.partsForClient')} <Help>{fromInfo('reservations.orderedParts')}</Help>
                                </div>

                                <div className="right">
                                    <button
                                        className="button button-small button-default"
                                        onClick={handleDownloadQuote}
                                        disabled={selectedPartsIds.length === 0}
                                    >
                                        <img src={downloadOfferImage} alt="download offer" />
                                        {trans('buttons.downloadOffer')}
                                    </button>
                                    <button
                                        ref={sendOfferButtonRef}
                                        className="button button-small button-default"
                                        onClick={e => setSendOfferAnchorEl(e.currentTarget)}
                                        disabled={selectedPartsIds.length === 0}
                                    >
                                        <img src={sendOfferImage} alt="send offer" />
                                        {trans('buttons.sendOffer')} &#x25BE;
                                    </button>
                                    <Menu
                                        anchorEl={sendOfferAnchorEl}
                                        open={Boolean(sendOfferAnchorEl)}
                                        onClose={() => setSendOfferAnchorEl(null)}
                                        keepMounted
                                    >
                                        <MenuItem onClick={() => handleSendQuote('email')}>
                                            {trans('buttons.sendByEmail')}
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSendQuote('viber')}>
                                            {trans('buttons.sendByViber') }
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSendQuote('whatsapp')}>
                                            {trans('buttons.sendByWhatsapp')}
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSendQuote('sms')}>
                                            {trans('buttons.sendBySMS') }
                                        </MenuItem>
                                    </Menu>
                                    {props.data.can_modify && reservation.can_modify_parts &&
                                        <button className="button button-add button-small" onClick={handleAddPart}>
                                            {trans("buttons.newPart")}
                                        </button>
                                    }
                                </div>
                            </div>

                            <Table
                                reservation={props.data}
                                data={parts.data}
                                loading={parts.loading}
                                handleUpdatePart={handleUpdatePart}
                                handleDeletePart={handleDeletePart}
                                refreshData={loadData}
                                selectedPartsIds={selectedPartsIds}
                                setSelectedPartsIds={setSelectedPartsIds}
                                setToIncludeLabourInQuote={setToIncludeLabourInQuote}
                            />
                        </div>

                        <div className='pannel'>
                            <div className='head'>
                                <div className='left'>
                                    {trans('headings.filesToAttachToOffer')} <Help>{fromInfo('reservations.attachedFiles')}</Help>
                                </div>
                                {props.data.can_modify &&
                                    <div className='right'>
                                        <button className="button button-small button-default" onClick={handleAttachFiles}>
                                            <img src={uploadFileImage} alt="attach file" />
                                            {trans('buttons.attachFile')}
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                            multiple
                                        />
                                    </div>
                                }
                            </div>
                            <TableFiles
                                reservation={props.data}
                                data={files.data}
                                loading={files.loading}
                                handleDeletePart={handleDeleteFile}
                                refreshData={loadData}
                                selectedFilesIds={selectedFilesIds}
                                setSelectedFilesIds={setSelectedFilesIds}
                            />
                        </div>

                        <div className='pannel'>
                            <div className='head'>
                                {trans('headings.usedVanParts')} <Help>{fromInfo('reservations.stockParts')}</Help>
                            </div>
                            <TableStock
                                reservation={props.data}
                                data={stockParts.data}
                                loading={stockParts.loading}
                                handleDeletePart={handleRemoveStockPart}
                                refreshData={loadStockData}
                            />
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default React.memo(Index, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})